
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { ConfigurationStore, UserStore } from '@/store/modules';
import { CategoricalEmail } from '@/store/models/configuration';

@Component({
  meta: {
    title: 'Send Email'
  },
  components: {
    QvInput,
    QvSelect,
    ValidationProvider,
    ValidationObserver,
    LocationInputMap
  }
})
export default class SendCategoricalEmail extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get categories() {
    return UserStore.Roles;
  }

  categoricalEmail: CategoricalEmail = {
    categories: [] as string[]
  } as CategoricalEmail;
  allCategory: boolean | null = false;

  selectAll(value: boolean) {
    if (value) {
      this.categoricalEmail.categories = this.categories.map(x => x.value);
      this.categoricalEmail.categories.push('all');
    } else {
      this.categoricalEmail.categories = [];
    }
  }

  changeAll() {
    const length = this.categoricalEmail.categories.filter(x => x != 'all')
      .length;
    if (length == this.categories.length) {
      this.allCategory = true;
      this.categoricalEmail.categories.push('all');
    } else if (length == 0) {
      this.allCategory = false;
      this.categoricalEmail.categories = this.categoricalEmail.categories.filter(
        x => x != 'all'
      );
    } else {
      this.allCategory = null;
      this.categoricalEmail.categories = this.categoricalEmail.categories.filter(
        x => x != 'all'
      );
    }
  }

  async onSubmit() {
    await ConfigurationStore.sendCategoricalEmail(this.categoricalEmail);
    this.$q.notify({
      type: 'positive',
      message: `Email sent`,
      caption: `Email sent to ${this.categoricalEmail.categories.join(
        ', '
      )} users.`
    });
  }
  onReset() {
    // eslint-disable-next-line
    this.categoricalEmail = { categories: [] as string[] } as CategoricalEmail;
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }

  created() {
    UserStore.getUserRoles();
  }
}
